module.exports = __webpack_public_path__ + "static/media/icons8-microsoft-excel-inactive.05d4368c.svg";